import styled from 'styled-components';
import { pallette } from '../../config/pallette';

export const Container = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const TopBanner = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid ${pallette.lightGray};
  height: 50px;

  @media (max-width: 1200px) {
    padding: 15px 0px;
  }
`;

export const LogoContainer = styled.div`
  width: 100%;

  @media (max-width: 1200px) {
    min-width: auto;
    width: calc(100svw - 30px);
  }

  @media (max-width: 1200px) {
    display: flex;
    align-items: start;
    padding-left: 15px;
  }
`;

export const MenuIconContainer = styled.div`
  display: none;

  @media (max-width: 1200px) {
    display: block;
    margin-left: auto;
    padding-right: 15px;
  }
`;
